module.exports = __webpack_public_path__ + "img/7.5e97e79e.jpg";